// Meta Pixel helper — initializes the pixel once and exposes track helpers.

const PIXEL_ID = '1720113316016666'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Bootstrap the fbq stub (queues calls until the real script loads)
  const w = window as any
  if (!w.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Inject the Meta Pixel script into the document head (safe insertion).
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const parent = document.head || document.body || document.documentElement
  if (parent) {
    parent.appendChild(script)
  }

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackAddToCart(
  params: { value?: number; currency?: string; content_name?: string } = {},
) {
  if (typeof window === 'undefined' || !(window as any).fbq) return
  ;(window as any).fbq('track', 'AddToCart', {
    currency: params.currency ?? 'USD',
    value: params.value ?? 9.99,
    content_name: params.content_name ?? 'Protocolo Mente Serena',
  })
}
